import ReactGA from 'react-ga4';

export const pageview = (title) => {
    ReactGA.send({
        hitType: 'pageview',
        page: window.location.pathname,
        title
    })
}
